/* src/app/components/sign-in/sign-in.component.scss */
mat-card {
  margin: 10px auto;
}
@media only screen and (min-width: 599px) {
  mat-card {
    margin: 75px auto;
    width: 400px;
  }
}
/*# sourceMappingURL=sign-in.component.css.map */
